import { DisplayOnce } from "../../utils/fw"
import { ModalWrapper, VimeoFrame } from "src/utils/fw-extension";

export default {
	background: "https://assets.swoogo.com/uploads/full/1391541-615c6b6b1875c.png",
	links: [
		{
			height: "10.5%",
			href: "/sponsor-speakers",
			label: "Sponsor Speakers",
			left: "2.2%",
			top: "70.5%",
			width: "14.8%",
		},
		{
			height: "10.5%",
			href: "/speaker-gallery",
			label: "Keynote Speakers",
			left: "82.2%",
			top: "70.5%",
			width: "14.8%",
		},
		{
			height: "16.1%",
			label: "Alex Jordan",
			left: "6.2%",
			modal: <VimeoFrame
				vidId="621812024?h=32de138201&autoplay=1"
			/>,
			top: "17.7%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Benoit Heynderickx",
			left: "14.1%",
			top: "17.7%",
			width: "7%",
			modal: <VimeoFrame
				vidId="621802758?h=c09e75d2ca&autoplay=1"
			/>
		},
		{
			height: "16.1%",
			label: "Eleanor Thrower",
			left: "22.1%",
			modal: <VimeoFrame
				vidId="621816233?h=90ddfeb3cc&autoplay=1"
			/>,
			top: "17.7%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Emma Bickerstaffe",
			left: "6.2%",
			modal: <VimeoFrame
				vidId="626322750?h=0ee73bb673&autoplay=1"
			/>,
			top: "36%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Gareth Haken",
			left: "14.2%",
			modal: <VimeoFrame
				vidId="621803892?h=8bdcf0e7bb&autoplay=1"
			/>,
			top: "36%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Mark Ward",
			left: "22.2%",
			modal: <VimeoFrame
				vidId="621797917?h=9ff756c417&autoplay=1"
			/>,
			top: "36%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Paul Holland",
			left: "6.2%",
			modal: <VimeoFrame
				vidId="621804567?h=ac11a70149&autoplay=1"
			/>,
			top: "54.3%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Paul Watts",
			left: "14.2%",
			modal: <VimeoFrame
				vidId="621816396?h=c2176f8f34&autoplay=1"
			/>,
			top: "54.3%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Richard Absalom",
			left: "22.2%",
			modal: <VimeoFrame
				vidId="621798864?h=610105b5ba&autoplay=1"
			/>,
			top: "54.3%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Carolyn Brown",
			left: "41.6%",
			modal: <VimeoFrame
				vidId="624378460?h=d894197d9d&autoplay=1"
			/>,
			top: "17.8%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Erika De Brito",
			left: "49.6%",
			modal: <VimeoFrame
				vidId="624378545?h=0a76f523bf&autoplay=1"
			/>,
			top: "17.8%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Ivo Gonçalves",
			left: "41.6%",
			modal: <VimeoFrame
				vidId="624378685?h=a4f1e2f080&autoplay=1"
			/>,
			top: "35.9%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Lucinda Libby",
			left: "49.6%",
			modal: <VimeoFrame
				vidId="624378953?h=0ae33499fd&autoplay=1"
			/>,
			top: "35.9%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Sarah Taylor",
			left: "41.6%",
			modal: <VimeoFrame
				vidId="624379785?h=5f0bbdf102&autoplay=1"
			/>,
			top: "54.3%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Steve Dobson",
			left: "49.6%",
			modal: <VimeoFrame
				vidId="621803447?h=93f49ccb03&autoplay=1"
			/>,
			top: "54.3%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Aman Behl",
			left: "71.4%",
			modal: <VimeoFrame
				vidId="621802203?h=22ab103e06&autoplay=1"
			/>,
			top: "17.8%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Bruce Page",
			left: "79.4%",
			modal: <VimeoFrame
				vidId="624378380?h=6e0cde555f&autoplay=1"
			/>,
			top: "17.8%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Chronis Kapalidis",
			left: "87.4%",
			modal: <VimeoFrame
				vidId="621813188?h=9abd4000ed&autoplay=1"
			/>,
			top: "17.8%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Dan Norman",
			left: "75.4%",
			modal: <VimeoFrame
				vidId="621796722?h=09bd36fc11&autoplay=1"
			/>,
			top: "35.9%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Matt Brett",
			left: "83.4%",
			modal: <VimeoFrame
				vidId="624379586?h=c1eef45812&autoplay=1"
			/>,
			top: "35.9%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Matt Kent",
			left: "71.4%",
			modal: <VimeoFrame
				vidId="624379683?h=b0af94055e&autoplay=1"
			/>,
			top: "54.3%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Mark Chaplin",
			left: "79.4%",
			modal: <VimeoFrame
				vidId="621801261?h=38043b31ff&autoplay=1"
			/>,
			top: "54.3%",
			width: "7%",
		},
		{
			height: "16.1%",
			label: "Martin Tully",
			left: "87.4%",
			modal: <VimeoFrame
				vidId="624379358?h=a068f41c9e&autoplay=1"
			/>,
			top: "54.3%",
			width: "7%",
		},
	],
	extras: <DisplayOnce id="isfspeakers-welcome">
		<ModalWrapper><p style={{color: "white"}}>Click on a frame to hear from these speakers</p></ModalWrapper>
	</DisplayOnce>,
	name: "isf-speakers",
}
